<!-- 右侧导航栏 -->
 <template>
  <el-menu
    :default-active="activeIndex"
    class="el-menu-vertical-demo"
    @open="handleOpen"
    @close="handleClose"
    active-text-color="#409EFF"
    text-color="#606266"
    :collapse="isCollapse"
    style="height: 100%; overflow-x: hidden;"
  >
    <div class="opzone">
      <img
        src="../../assets/images/unfold.png"
        alt
        class="opicon"
        v-if="isCollapse"
        @click="changeCollapse(false)"
      />
      <img
        src="../../assets/images/fold.png"
        alt
        class="opicon"
        v-else
        @click="changeCollapse(true)"
      />
    </div>
    <template v-for="(item,index) in nav.Children">
      <el-submenu :index="item.Item.Url" :key="index" v-if="item.Children.length>0">
        <template slot="title">
          <i :class="item.Item.IconName"></i>
          <span slot="title">{{ item.Item.Name }}</span>
        </template>
        <el-menu-item
          :index="childItem.Item.Url"
          :key="index2"
          v-for="(childItem, index2) in item.Children"
          @click="toPage(childItem.Item.Url, item, childItem)"
        >
          <span
            :style="marginStyle"
            slot="title"
          >{{ childItem.Item.Name }}</span>
        </el-menu-item>
      </el-submenu>
      <el-menu-item v-else :key="index" :index="item.Item.Url" @click="toPage(item.Item.Url, item)">
        <i :class="item.Item.IconName"></i>
        <span slot="title">{{ item.Item.Name }}</span>
      </el-menu-item>
    </template>
  </el-menu>
</template>
<script>
export default {
  name: "navLeft",
  props: ["nav"],
  data() {
    return {
      activeIndex: "",
      isCollapse: false,
      marginStyle: "margin-left:60px;"
    };
  },
  mounted() {
    //默认加载页面
    let route = this.$route;
    let activeUrl = "";
    if (this.nav.Children[0].Item.Url != route.path) activeUrl = route.path;
    else {
      activeUrl = this.nav.Children[0].Item.Url;
    }
    this.activeIndex = activeUrl;

    this.isCollapse = this.$util.getLocalStorage("isCollapse");
    if (!this.isCollapse) this.isCollapse = false;
  },
  methods: {
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    toPage(url, firstLevel, secoundLevel) {
      // 防止重复点击
      if (this.$route.path !== url) {
        this.$router.push(url);
      }
      // 修改页面标题
      if (firstLevel && firstLevel.Item.Name) {
        document.title = `${firstLevel.Item.ParentName} - ${
          secoundLevel && secoundLevel.Item.ParentName ?
            secoundLevel.Item.Name : firstLevel.Item.Name
        }`
      } else {
        document.title = '车回佳企业客户端管理系统';
      }
    },
    changeCollapse(state) {
      if (state) {
        this.isCollapse = true;
        this.marginStyle = "margin-left:10px;";
        this.$util.setLocalStorage("isCollapse", true);
      } else {
        this.isCollapse = false;
        this.marginStyle = "margin-left:40px;";
        this.$util.setLocalStorage("isCollapse", false);
      }
    }
  }
};
</script>
<style lang="less">
.el-menu-vertical-demo {
  z-index: 999;
  .el-menu-item,
  .el-submenu__title {
    padding: 0 0 0 10px !important;
    height: 42px;
    line-height: 42px;
  }
  .el-submenu {
    .el-submenu__icon-arrow {
      right: 8px;
    }
    .el-menu-item {
      span {
        margin-left: 40px !important;
      }
    }
  }
}
.el-menu--collapse {
  .el-submenu__title {
    padding: 0 20px !important;
  }
}
</style>
<style lang="less" scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 160px;
  min-height: 400px;
}
.opzone {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.opicon {
  width: 25px;
  height: 25px;
  margin: 5px 5px 0 0;
  background-color: #bbbaba;
  padding: 3px;
}
</style>
